import assetPath from '/app/packages/lebenslauf/articles/src/assets/test.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')